module.exports = __webpack_public_path__ + "static/img/24.4ecb133.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/24.jpg
// module id = OTyt
// module chunks = 0